import { memo } from 'react';
import { ImageProps } from '../assets/images/imageType';

// 이미지 추가시 src/assets/images/index.ts 배열에 추가
export const Image = memo(({ src, alt = '이미지' }: ImageProps) => {
  return <img src={src} alt={alt} width="100%" />;
});

Image.displayName = 'Image';
